import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-876cbc50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fieldWrapper" }
const _hoisted_2 = { style: {"display":"flex"} }
const _hoisted_3 = {
  key: 0,
  class: "label"
}
const _hoisted_4 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_5 = { class: "checkbox" }
const _hoisted_6 = ["checked", "disabled"]

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormCheckboxField',
  props: {
    modelValue: { type: Boolean },
    label: null,
    description: null,
    boxLabel: null,
    validator: null,
    validationId: null,
    isDisabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue?: boolean,
  label?: string,
  description?: string,
  boxLabel: string,
  validator?: (fieldId: any, val: any) => boolean,
  validationId?: string,
  isDisabled?: boolean
}






// The input element where the form field's value will be bound
const inputElem = ref<any>(null);

// Event for two-way binding
const onInput = () => {
  emit('update:modelValue', inputElem.value.checked);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.label)
        ? (_openBlock(), _createElementBlock("label", _hoisted_3, _toDisplayString(__props.label), 1))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "top")
    ]),
    (__props.description)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(__props.description), 1))
      : _createCommentVNode("", true),
    _createElementVNode("label", _hoisted_5, [
      _createElementVNode("input", {
        ref_key: "inputElem",
        ref: inputElem,
        type: "checkbox",
        class: _normalizeClass(["mr-3", { 'is-danger': __props.validator ? !__props.validator(__props.validationId ? __props.validationId : this, __props.modelValue) : false }]),
        checked: __props.modelValue,
        onChange: _cache[0] || (_cache[0] = ($event: any) => (onInput())),
        disabled: __props.isDisabled
      }, null, 42, _hoisted_6),
      _createTextVNode(" " + _toDisplayString(__props.boxLabel), 1)
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})